import { useState, useEffect } from 'react'
import socket from '../app/socket'

export const useSocketConnect = ({ name, callback: listener }) => {

  useEffect(() => {

    socket.on('connect', listener)
    //console.log('[useSocketConnect] socket.on', name)

    return () => {
      socket.off('connect', listener)
      //console.log('[useSocketConnect] socket.off', name)
    }

  }, [])

}

export default useSocketConnect
